<template>
    <div class="card mt-1">
        <div class="card-body">
            <div class=" d-flex justify-content-between align-items-center">
                <div>
                    <button class="btn" @click="goToPrevious" :disabled="isFirstItem">
                        <img class="arrow-icon" src="@/assets/images/icon/prev.png" />
                    </button>
                    <button class="btn" @click="goToNext" :disabled="isLastItem">
                        <img class="arrow-icon" src="@/assets/images/icon/next.png" />
                    </button>
                </div>
                <div>
                    <button class="btn" @click="$emit('close')">
                        <img class="close-btn" src="@/assets/images/icon/close.png" />
                    </button>
                </div>
            </div>
            <div class=" d-flex justify-content-between align-items-center p-2 mt-4">
                <div class="transaction-title">Settlements details</div>
            </div>
            <div  class="p-2">
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Date</div> 
                    <div class="col-value">
                        {{ formatDate(currentSettlement.created_at) }}
                    </div>
                </div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Time</div> 
                    <div class="col-value">
                        {{ formatTime(currentSettlement.created_at) }}
                    </div>
                </div>
                <div class="col-line"></div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Payment status</div> 
                    <div class="col-value" :class="currentSettlement.payment_status == 'Settled' ? 'text-green':''">
                        {{ currentSettlement.payment_status }}
                    </div>
                </div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Settlement Reference</div> 
                    <div class="col-value">
                        {{ currentSettlement.settlement_ref }}
                    </div>
                </div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div></div> 
                    <p class=" d-flex justify-content-end">
                        <span class="view-trans" @click="viewTransactions">View transactions</span>
                    </p>                
                </div>
                <div class="col-line"></div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Face value</div> 
                    <div class="col-value">
                        {{ formatCurrency(currentSettlement.face_value) }}
                    </div>
                </div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Commission</div> 
                    <div class="col-value">
                        {{ formatCurrency(currentSettlement.commission) }}
                    </div>
                </div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Fees & bond</div> 
                    <div class="col-value">
                        {{ formatCurrency(currentSettlement.deposit) }}
                    </div>
                </div>
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-title">Refunds</div> 
                    <div class="col-value">
                        {{ formatCurrency(currentSettlement.refunds) }}
                    </div>
                </div>
                <div class="pay-line"></div> 
                <div class="col-item d-flex justify-content-between align-items-center">
                    <div class="col-amount">Total amount</div> 
                    <div class="col-pay">
                        {{ formatCurrency(currentSettlement.total_amount) }}
                    </div>
                </div>
                <!-- 下載結算報告按鈕 -->
                <div class="mt-5">
                <button class="btn detail-download d-flex justify-content-between" @click="handEmailAndPrint(currentSettlement.id)">
                    Download settlement report
                    <i class="fa fa-download"></i>
                </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script setup>
import { computed, reactive, watch, defineProps } from 'vue';
import { useSettlementStore } from '@/store/driver/settlement';
import { useTransactionStore } from '@/store/driver/transaction';
import { useCashPaymentStore } from '@/store/admin/cashPayment/cashpayment';

import { useRouter, onBeforeRouteLeave } from 'vue-router';



const props = defineProps({
  initialIndex: Number
});

const settlementStore = useSettlementStore();
const transactionStore = useTransactionStore();
const cashPaymentStore = useCashPaymentStore();

const router = useRouter();

// 直接使用 settlementStore.settlements
const allSettlements = computed(() => settlementStore.settlements);

// 使用 reactive 追蹤當前索引
const state = reactive({
  currentIndex: props.initialIndex
});

// 取得當前的交易資料
const currentSettlement = computed(() => {
  if (!allSettlements.value || !Array.isArray(allSettlements.value)) {
    return {};
  }
  return allSettlements.value[state.currentIndex] || {};
});

// 判斷是否為第一筆或最後一筆交易
const isFirstItem = computed(() => state.currentIndex === 0);
const isLastItem = computed(() => state.currentIndex === (allSettlements.value?.length || 0) - 1);

// 前往上一筆交易
const goToPrevious = () => {
  if (!isFirstItem.value) {
    state.currentIndex--;
  }
};

// 前往下一筆交易
const goToNext = () => {
  if (!isLastItem.value) {
    state.currentIndex++;
  }
};

// 格式化日期函數
const formatDate = (date) => {
  // 檢查是否為 Date 對象，若不是則嘗試轉換
  if (!(date instanceof Date)) {
    date = new Date(date);
  }

  // 檢查是否成功轉換為有效的 Date 對象
  if (isNaN(date.getTime())) {
    return "Invalid Date"; // 返回一個預設值或錯誤信息
  }

  const day = date.getDate().toString().padStart(2, '0');
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};


// 格式化時間函數
const formatTime = (datetime) => {
  const date = new Date(datetime);
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  // 直接回傳 24 小時格式，不需要轉換成 12 小時制
  return `${hours.toString().padStart(2, '0')}:${minutes}`;
};


// 格式化貨幣函數
const formatCurrency = (value) => {
  const absValue = Math.abs(value);
  return value < 0 ? `-$${absValue}` : `$${absValue}`;
};

const viewTransactions = async () => {
  transactionStore.filters.reference = currentSettlement.value.settlement_ref;
  transactionStore.shouldResetFilters = false;

  await router.push({ path: '/transaction' });
};

const handEmailAndPrint = async (id)=>{
    await cashPaymentStore.printPayments(id); // 獲取付款信息
};

// 使用 onBeforeRouteLeave 鉤子來清空篩選條件
onBeforeRouteLeave(() => {
  // 清空篩選條件
  settlementStore.filters.fromDate = '';
  settlementStore.filters.toDate = '';
  settlementStore.filters.reference = '';

  transactionStore.shouldResetFilters = true;
  settlementStore.currentPage = 1;
});

// 監聽 initialIndex 的變化，當初始索引改變時更新 currentIndex
watch(
  () => props.initialIndex,
  (newIndex) => {
    state.currentIndex = newIndex;
  }
);
</script>

<style scoped>
.card {
    position: absolute;
    top: 80px;
    left: 0;
    right: 0;
    z-index: 1;
    height: 100%;
    width: 100%; /* 設置寬度為 100% */
    overflow-y: auto;
    overflow-x: hidden; /* 防止左右滑動 */
    border-radius: 10px 10px 0px 0px;
}

.view-trans{
  cursor: pointer;
  font-size: 16px;
  color: #8476f4;
  border-bottom: 1px solid #8476f4;
}

.transaction-title{
    width: auto;
    height: 30px;

    /* Portal/Portal – H4 bold */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;

    /* 1E1E2D */
    color: #1E1E2D;
}

.arrow-icon{
  width: 12px;
  height: 20px;
}

.close-btn {
    width: 22px;
    height: 22px;
}

.col-item{
    margin-top: 20px;
    margin-bottom: 20px;
}

.col-title{
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;

    /* Navy */
    color: #051C2C;
}

.col-value{
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    text-align: right;

    color: #051C2C;
}

.col-amount{
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 23px;
    display: flex;
    align-items: center;

    color: #051C2C;
}

.col-pay{
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 25px;
    display: flex;
    align-items: center;
    text-align: right;

    /* Navy */
    color: #051C2C;
}

.col-line{
    margin-top: 30px;
    margin-bottom: 30px;
    border: 1px solid #99A6B4;
}

.payment-icon{
    width: auto;
    height: 18px;
}

.text-refund{
    color: #189F95;
}

.text-green{
    color: #00c962;
}

.text-red{
    color: red;
}

.pay-line{
    border: 1px solid #E6E9EC;
}

.detail-download {
    width: 100%;
    border: 2px inset #d9dde3;
    padding: 10px;
    font-size: 16px;
}

.detail-download i {
    font-size: 24px;
}
</style>

